<template>
  <div>
    <div class="cert-header d-flex py-5">
      <div class="col-12 col-md-11 col-lg-10 col-xl-9 px-3 p-md-0 mx-auto">
        <div ref="title" class="cert-title cert-large">Services</div>
      </div>
    </div>
    <div ref="content"
         class="col-12 col-md-11 col-lg-10 col-xl-9 p-2 p-sm-5 mx-auto mt-2 mt-sm-5 cert-page-content  d-flex flex-column">
      <div ref="i1">
        <cert-service-details-container title="Preventive Services"
                                        content="Detect & prevent attacks before there is an actual impact on the production systems. In this category of services, the information generated by the Rw-CERT is disseminated and distributed to constituencies and partners in the form of protection measures, to help these entities avoid becoming the victims of attacks."
                                        icon="policy" link="/about#proactive"
                                        :separator="true"
                                        :services="proactive"
                                        :expanded="expanded==='proactive'"
        />
      </div>
      <div ref="i2">
        <cert-service-details-container class="col-4" title="Response Services"
                                        content="Respond to an incident in order to contain the situation, minimize damage and draw lessons for future preventions."
                                        icon="electric_bolt" link="/about#reactive"
                                        :separator="true"
                                        :services="reactive"
                                        :expanded="expanded==='reactive'"
        />
      </div>
      <div ref="i3">
        <cert-service-details-container class="col-4" title="Security Quality Management"
                                        content="Requested by a constituency for review and improvement of the security posture of their system infrastructure."
                                        icon="admin_panel_settings" link="/about#management"
                                        :separator="false"
                                        :services="quality"
                                        :expanded="expanded==='management'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CertServiceDetailsContainer from './components/CertServiceDetailsContainer.vue';

export default {
  name: "Services",
  components: {
    CertServiceDetailsContainer,
  },

  data() {
    return {
      expanded: null,
      proactive: [
        "Security Audits, Vulnerability assessment and Pentests",
        "Technology watch",
        "Security-Related Information Dissemination",
        "Child online protection",
        "Cooperation with other CSIRT/CERT teams",
        "Vulnerability assessment and penetration testing",
      ],
      reactive: [
        "Timely alerts and warnings",
        "Cyber Incident response coordination",
        "Cyber threat information sharing",
        "Incident artifacts handling",
      ],
      quality: [
        "Cyber security risk assessment",
        "Business Continuity and Disaster Recovery Planning",
        "Cyber Security Consultations and awareness",
        "Education/Training on cybersecurity"
      ],
    };
  },
  created() {
    this.expanded = this.$route.params.expand;
  },
  mounted() {
    this.$anim.fadeInBottomOpaque(this.$refs["content"], 50);
    for (let i = 1; i < 4; i++)
      this.$anim.fadeInBottom(this.$refs[`i${i}`], 80 * i);
  }
}
</script>